module.exports = __webpack_public_path__ + "static/media/logo_acsi.957317b4.jpg";